<template>
  <div class="dashboard">
    <h2 class="page-title">客户端配置管理</h2>
    
    <!-- 搜索和操作区域 -->
    <el-row v-if="isMobile" :gutter="20" class="toolbar">
      <el-col :xs="24" :sm="16">
        <el-input
          v-model="searchKeyword"
          placeholder="输入产品名称搜索"
          clearable
          @clear="search"
          @keyup.enter.native="search"
          class="search-input"
        >
          <el-button slot="append" icon="el-icon-search" @click="search" />
        </el-input>
      </el-col>
      <el-col :xs="24" :sm="8" class="action-buttons">
        <el-button-group class="mobile-button-group">
          <el-button 
            type="info" 
            icon="el-icon-refresh" 
            @click="handleRefresh"
            :loading="refreshLoading"
            class="btn-refresh"
          ></el-button>
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd"></el-button>
          <el-button type="danger" icon="el-icon-delete" @click="batchDelete"></el-button>
        </el-button-group>
      </el-col>
    </el-row>

    <el-row v-else :gutter="20" class="toolbar">
      <el-col :span="16">
        <el-input
          v-model="searchKeyword"
          placeholder="输入产品名称搜索"
          clearable
          @clear="search"
          @keyup.enter.native="search"
        >
          <el-button slot="append" icon="el-icon-search" @click="search" />
        </el-input>
      </el-col>
      <el-col :span="8" class="text-right">
        <el-button 
          type="info" 
          icon="el-icon-refresh" 
          @click="handleRefresh"
          :loading="refreshLoading"
        >刷新</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <el-button type="danger" icon="el-icon-delete" @click="batchDelete">删除</el-button>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table
      :data="filteredData"
      stripe
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="responsive-table"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="target" label="产品" width="180" />
      <el-table-column prop="active" label="激活码" class-name="mobile-hidden" />
      <el-table-column prop="register" label="注册码" class-name="mobile-hidden" />
      <el-table-column prop="retainDay" label="次留码" class-name="mobile-hidden" />
      <el-table-column prop="wake" label="唤醒码" />
      <el-table-column prop="pay" label="付费码" />
      <el-table-column label="操作" width="150" class-name="operation-column">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)" class="btn-edit">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row)" class="btn-delete">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible" 
      :width="dialogWidth"
      :close-on-click-modal="false"
      top="5vh"
      custom-class="mobile-dialog"
    >
      <el-form 
        :model="form" 
        :rules="rules"
        ref="form"
        label-width="120px"
        class="compact-form"
      >
      <el-form-item label="产品" prop="target">
        <el-input v-no-space v-model="form.target" placeholder="请输入产品名称" />
      </el-form-item>
      
      <!-- 修改后的数字输入字段 -->
      <el-form-item label="激活返回码" prop="active">
        <el-input 
          v-model.number="form.active"
          type="number"
          min="0"
          @input="handleNumberInput('active')"
        />
      </el-form-item>
      
      <!-- 其他数字字段同理修改 -->
      <el-form-item label="注册返回码" prop="register">
        <el-input 
          v-model.number="form.register"
          type="number"
          min="0"
          @input="handleNumberInput('register')"
        />
      </el-form-item>
      
      <el-form-item label="次留返回码" prop="retainDay">
        <el-input 
          v-model.number="form.retainDay"
          type="number"
          min="0"
          @input="handleNumberInput('retainDay')"
        />
      </el-form-item>
      
      <el-form-item label="唤醒返回码" prop="wake">
        <el-input 
          v-model.number="form.wake"
          type="number"
          min="0"
          @input="handleNumberInput('wake')"
        />
      </el-form-item>
      
      <el-form-item label="付费返回码" prop="pay">
        <el-input 
          v-model.number="form.pay"
          type="number"
          min="0"
          @input="handleNumberInput('pay')"
        />
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false" class="btn-cancel">取 消</el-button>
      <el-button type="primary" @click="handleSave" class="btn-confirm">确 定</el-button>
    </span>
  </el-dialog>
  </div>
</template>

<script>
import {clientConfigList, addClientConfig, updateClientConfig, DelClientConfig} from '../api/index'

export default {
  name: 'ClientConfig',
  data() {
    // 验证规则配置
    const validateNumber = (rule, value, callback) => {
      if (!Number.isInteger(value)) {
        callback(new Error('必须为整数'));
      } else if (value < 0) {
        callback(new Error('不能小于0'));
      } else {
        callback();
      }
    };

    return {
      searchKeyword: '',
      tableData: [],
      ver:'',
      multipleSelection: [],
      dialogVisible: false,
      dialogTitle: '新增配置',
      form: {
        target: '',
        active: 0,
        register: 0,
        retainDay: 0,
        wake: 0,
        pay: 0
      },
      rules: {
        target: [
          { required: true, message: '产品名称不能为空', trigger: 'blur' }
        ],
        active: [
          { required: true, message: '激活码不能为空', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        register: [
          { required: true, message: '注册码不能为空', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        retainday: [
          { required: true, message: '次留码不能为空', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        wake: [
          { required: true, message: '唤醒码不能为空', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ],
        pay: [
          { required: true, message: '付费码不能为空', trigger: 'blur' },
          { validator: validateNumber, trigger: 'blur' }
        ]
      },
    }
  },
  computed: {
    // 新增计算属性
    filteredData() {
      const keyword = this.searchKeyword.toLowerCase()
      if (!keyword) return this.tableData
      
      return this.tableData.filter(item => 
        item.target.toLowerCase().includes(keyword)
      )
    },
    dialogWidth() {
      return this.isMobile ? '90%' : '500px'
    },
    isMobile() {
      return window.innerWidth < 768
    }
  },
  created(){
    this.getList()
  },
  methods: {
    getList(){
        this.refreshLoading = true
        clientConfigList().then(res => {
            this.tableData = res.data
            if(this.tableData.length == 0)
            {
              this.$message.info('没有数据')
            }
            this.ver = res.version
            this.refreshLoading = false
      }).catch(error => {
         this.$message.error('数据获取失败:'+error)
        this.refreshLoading = false
      })
    },
    async handleRefresh() {
        this.getList()
        this.$message.success("已刷新")
    },
    search() {
      // 计算属性会自动更新，这里只需清空选择
      this.multipleSelection = []
    },
    handleAdd() {
      this.dialogTitle = '新增配置'
      this.form = this.resetForm()
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑配置'
      this.form = Object.assign({}, row)
      this.dialogVisible = true
    },
    handleDelete(row) {
      this.$confirm('确认删除该配置?', '提示', {
        type: 'warning'
      }).then(() => {
        DelClientConfig({Targets:[row.target],version:this.ver}).then(()=>{
          this.$message.success("删除成功")
          this.getList()
        }).catch(err=>{
          this.$message.error("删除失败:"+err)
        })
      })
    },
    batchDelete() {
      if (!this.multipleSelection.length) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除选中配置?', '提示', {
        type: 'warning'
      }).then(() => {
          var dels = []
          this.multipleSelection.forEach(item => {
            dels.push(item.target)
          })
          DelClientConfig(dels).then(()=>{
          this.$message.success("删除成功")
          this.getList()
        }).catch(err=>{
          this.$message.error("删除失败:"+err)
        })
      })
    },
    handleSave() {
        this.$refs.form.validate(valid => {
        if (!valid) return;
        // 保存逻辑保持不变...
        if (this.dialogTitle === '新增配置') {
            addClientConfig(this.form).then(res => {
                if(res.code == 1)
                {
                    this.getList()
                    this.dialogVisible = false;
                    this.$message.success('保存成功');
                }
            }).catch(() => {
                this.$message.error('添加失败')
            })
        } else {
          updateClientConfig({...this.form,version:this.ver}).then(res => {
              if(res.code == 1)
              {
                  this.getList()
                  this.dialogVisible = false;
                  this.$message.success('保存成功');
              }
          }).catch(() => {
              this.$message.error('修改失败')
          })
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    resetForm() {
      return {
        target: '',
        active: 0,
        register: 0,
        retainDay: 0,
        wake: 0,
        pay: 0
      }
    },
    handleNumberInput(field) {
      // 即时转换为整数
      if (typeof this.form[field] === 'string') {
        this.form[field] = parseInt(this.form[field]) || 0;
      }
      // 限制最小值
      if (this.form[field] < 0) {
        this.form[field] = 0;
      }
    },
  }
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.toolbar {
  margin-bottom: 20px;
}

.text-right {
  text-align: right;
}

.el-table {
  margin-top: 15px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
}

.el-dialog__body {
  padding: 20px 30px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .page-title {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }

  .toolbar {
    margin-bottom: 10px;
  }

  .search-input {
    margin-bottom: 10px;
  }

  .action-buttons {
    text-align: left;
  }

  .mobile-button-group {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .mobile-button-group .el-button {
    flex: 1;
    padding: 12px 5px;
    margin: 0 3px;
  }

  .responsive-table {
    overflow-x: auto;
  }

  .operation-column .el-button {
    padding: 5px;
    margin: 2px;
    font-size: 12px;
  }

  .mobile-hidden {
    display: none;
  }

  .compact-form .el-form-item {
    margin-bottom: 15px;
  }

  .compact-form .el-input {
    width: 100%;
  }

  .mobile-dialog {
    max-width: 100%;
  }

  .dialog-footer .el-button {
    width: 48%;
    padding: 12px;
  }
}



@media (min-width: 769px) {
  .mobile-button-group {
    display: none;
  }
}

</style>